import * as React from 'react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { FormError } from '../../../../../../components/FormError'
import { ComplianceStore } from '../../ComplianceStore'
import { Button, Input } from 'antd'
import { Track } from '../../../../../../Track'
import { SKComplianceModels, BaseComplianceApi } from '@getgreenline/compliance'
import { CompaniesModels } from '@getgreenline/companies'
import { parseErrorMsg } from '../../../../../../utilities/helpers'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  complianceStore: ComplianceStore
}

interface State {
  site: string
  isLoading: boolean
  errorMessage?: string
}

export class SKTransactionsReport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      site: '',
      isLoading: false,
    }
  }

  generate = async () => {
    const { month, year, locationIds } = this.props.complianceStore
    const { site } = this.state

    if (site === '') {
      return this.setState({ errorMessage: 'Please enter a Site ID' })
    }

    const params: SKComplianceModels.SKBaseComplianceReportRequest = {
      month,
      year,
      site,
      locationIds,
      reportType: SKComplianceModels.SKReportType.TRANSACTIONS,
    }

    Track.track('dashboard:compliance_complianceReportGenerated', params)
    const company = this.props.currentCompanyStore!.company!
    this.setState({
      isLoading: true,
      errorMessage: undefined,
    })

    try {
      const response = await BaseComplianceApi.getComplianceReport(
        company.id,
        CompaniesModels.Province.SK,
        params,
      )

      const blob = new Blob([response])
      const a = window.document.createElement('a')
      a.href = (window.URL as any).createObjectURL(blob, { type: 'text/plain' } as any)
      a.download = this.props.complianceStore.generateFileName(company.name, 'csv')
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } catch (error) {
      this.setState({ errorMessage: parseErrorMsg(error) })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render() {
    const { isLoading, errorMessage, site } = this.state
    const { locationIds } = this.props.complianceStore

    return (
      <div>
        <div>
          <div className='row form-group'>
            <label className='mb-0 col-md-6'>Site ID (SKR####-##)</label>
            <div className='col-md-6'>
              <Input
                className='form-control'
                value={site}
                onChange={(e) => this.setState({ site: e.target.value })}
              />
            </div>
          </div>
        </div>

        <div>
          <div>
            <Button
              type='primary'
              onClick={this.generate}
              loading={locationIds.length === 0 || isLoading}
            >
              {isLoading ? 'Downloading...' : 'Download report'}
            </Button>
          </div>
          <FormError message={errorMessage} />
        </div>
      </div>
    )
  }
}
